import { render, staticRenderFns } from "./DocumentoCompraDireta.vue?vue&type=template&id=4b8cc23e&scoped=true"
import script from "./DocumentoCompraDireta.vue?vue&type=script&lang=js"
export * from "./DocumentoCompraDireta.vue?vue&type=script&lang=js"
import style0 from "./DocumentoCompraDireta.vue?vue&type=style&index=0&id=4b8cc23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8cc23e",
  null
  
)

export default component.exports